import type { FaireProductEntity } from "../../entity_types/product";

export const p_w73379ysdf: FaireProductEntity = {
  token: "p_w73379ysdf",
  type: "product",
  name: "Apple a Day Tea Towel",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1adfd6b3a72196401cf3068baea118258d6fa918355a8f61efa4c38574e55883.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/570ce9a21ea7e4b1c97494f861d155389f6cf33132ea399dbe230e01915935b2.jpeg",
    "https://cdn.faire.com/fastly/65fa4175810d38eab204c9996a697647e9d74f936e0aa4b281e063b300e72ebd.jpeg",
    "https://cdn.faire.com/fastly/90d3fdb3eff604e0e3e4a4a0cfbc8d29352ec76aa11ed9b349d9f1b0bba27811.jpeg",
  ],
  priceDollars: 11,
  description:
    'Let\'s get some COLOR in the kitch! Add some flavor! These E. Frances towels are full of personality.... perfect for juicy spills and happy kitchens.\n\n100% cotton\n21" x 28" ',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:52.829Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
